import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';

const AdminDeleted = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [Admin, setAdmin] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState([]);
  const tableRef = useRef(null);

  const fetchAdmin = async () => {
    try {
      const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
      const response = await fetch(`${baseurl}/admin/deletedadmin`, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`, // Ensure token is sent
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      const formattedData = data.map(admin => ({
        ...admin,
      }));
      setAdmin(formattedData);
    } catch (error) {
      console.error('Error fetching admin:', error);
    }
  };

  useEffect(() => {
    fetchAdmin();
  }, []);

  useEffect(() => {
    const tableElement = tableRef.current;
  
    if (tableElement) {
      if ($.fn.DataTable.isDataTable(tableElement)) {
        $(tableElement).DataTable().destroy();
      }
  
      const dataTable = $(tableElement).DataTable({
        dom: 'Blfrtip',
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
        buttons: [
          { extend: 'copyHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'csvHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'pdfHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'print', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        ],
        data: Admin,
        columns: [
          {
            data: null,
            title: '<input type="checkbox" id="select-all" />',
            orderable: false,
            render: (data, type, row) => `<input type="checkbox" class="row-select" data-id="${row.admin_id}" />`,
          },
          { data: null, title: "Sr.No", className: "text-center" },
          { data: 'name', title: 'Name' },
          { data: 'mobileno', title: 'Mobile No' },
          { data: 'email', title: 'Email' },
          { data: 'chapter_name', title: 'Chapter Name' },
          { data: 'role_name', title: 'Role' },
          { data: null, title: 'Action', orderable: false },
        ],
        columnDefs: [
          {
            targets: 1,
            render: (data, type, row, meta) => meta.row + 1,
          },
          {
            targets: 2,
            render: (data) => `<center>${data}</center>`,
          },
          {
            targets: 7,
            render: (data, type, row) => {
              const restoreIcon = `<a href="#" class="restore-icon btn btn-warning btn-sm me-2" data-id="${row.admin_id}"><i class="fas fa-trash-arrow-up"></i>&nbsp; Restore</a>`;
              const deleteIcon = roleid === 1 ? `<a href="#" class="delete-icon btn btn-danger btn-sm" style="color:white" data-id="${row.admin_id}"><i class="fas fa-trash"></i> Delete Forever</a>` : '';
              return `${restoreIcon} ${deleteIcon}`;
            },
          },
        ],
      });
  
      // Select all checkboxes
$(document).on("click", "#select-all", function () {
  const checked = this.checked;

  // Get only visible Admin IDs
  const visibleAdminIds = $(".row-select")
    .map(function () {
      return $(this).data("id");
    })
    .get(); // Convert jQuery object to array

  // Set selected Admin based on whether "Select All" is checked
  setSelectedAdmin(checked ? [...new Set(visibleAdminIds)] : []);
  
  $(".row-select").each(function () {
    $(this).prop("checked", checked).trigger("change");
  });
});

$(document).on('change', '.row-select', function () {
  const AdminId = $(this).data('id');
  if (this.checked) {
    // Add the Admin ID only if it's not already in the selectedAdmin
    setSelectedAdmin((prev) => [...new Set([...prev, AdminId])]);
  } else {
    // Remove the Admin ID from selectedAdmin
    setSelectedAdmin((prev) => prev.filter((id) => id !== AdminId));
  }
});
  
      $(document).on('click', '.delete-icon', async function (e) {
        e.preventDefault();
        if (selectedAdmin.length === 0) {
          Swal.fire('No Admin Selected', 'Please select Admin to delete.', 'warning');
          console.log('No Admin selected', selectedAdmin); // Add a log for debugging
          return;
        }
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to permanently delete the selected Admin?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await Promise.all(
              selectedAdmin.map(AdminId =>
                $.ajax({
                  url: `${baseurl}/admin/delete/${AdminId}?permanentdelete=true`,
                  type: 'DELETE',
                  headers: {
                    Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
                  },
                })
              )
            );
            Swal.fire('Deleted!', 'Selected Admin deleted successfully.', 'success');
            fetchAdmin(); // Re-fetch the Admin after deletion
            setSelectedAdmin([]); // Clear selected Admin
          } catch (error) {
            console.error('Error deleting selected Admin:', error);
            Swal.fire('Error', 'Error deleting selected Admin.', 'error');
          }
        }
      });


      $(document).on('click', '.restore-icon', async function (e) {
        e.preventDefault();
        const AdminId = $(this).data('id');
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to Restore this Admin?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Restore!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await $.ajax({
              url: `${baseurl}/admin/restore/${AdminId}`,
              type: 'PUT',
              headers: {
                Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
              },
            });
            Swal.fire('Restored!', 'Admin Restore successfully.', 'success');
            // Re-fetch the Admin after deletion
            fetchAdmin();
          } catch (error) {
            console.error('Error Restore Admin:', error);
            Swal.fire('Error', 'Error Restore Admin.', 'error');
          }
        }
      });

      $(document).on('click', '.delete-icon', async function (e) {
        e.preventDefault();
        const AdminId = $(this).data('id');
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to permanently delete this Admin?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await $.ajax({
              url: `${baseurl}/admin/delete/${AdminId}?permanentdelete=true`,
              type: 'DELETE',
              headers: {
                Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
              },
            });
            Swal.fire('Deleted!', 'Admin permanently deleted successfully.', 'success');
            // Re-fetch the Admin after deletion
            fetchAdmin();
          } catch (error) {
            console.error('Error deleting Admin:', error);
            Swal.fire('Error', 'Error deleting Admin.', 'error');
          }
        }
      });

      return () => {
        if ($.fn.DataTable.isDataTable(tableElement)) {
          $(tableElement).DataTable().destroy();
        }
      };
    }
  }, [Admin]);
  
  // Function to delete selected Admin
  const handleDeleteSelected = async () => {
    console.log("Selected Admin before deletion:", selectedAdmin);
  
    if (selectedAdmin.length === 0) {
      Swal.fire("No Admin Selected", "Please select Admin to delete.", "warning");
      return;
    }
  
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to permanently delete the selected Admin?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {
        const token = sessionStorage.getItem("token");
  
        await Promise.all(
          selectedAdmin.map((AdminId) =>
            $.ajax({
              url: `${baseurl}/admin/delete/${AdminId}?permanentdelete=true`,
              type: "DELETE",
              headers: {
                Authorization: `${token}`,
              },
            }).fail((jqXHR, textStatus, errorThrown) => {
              console.error(`Failed to delete Admin ID ${AdminId}:`, textStatus, errorThrown);
            })
          )
        );
  
        Swal.fire("Deleted!", "Selected Admin deleted successfully.", "success");
  
        fetchAdmin();
        setSelectedAdmin([]); // Reset selectedAdmin after deletion**
      } catch (error) {
        console.error("Error deleting selected Admin:", error);
        Swal.fire("Error", "Error deleting selected Admin.", "error");
      }
    }
  };
  

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  
  return (
    <div className="content container-fluid">
      <center><h1>Admin Deleted Entries</h1></center>
      <div className="container mt-4">
        <div className="profile-section">
          <button onClick={handleDeleteSelected} className="btn btn-danger mb-3">Delete Selected List</button>
          <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <div className="col-12">
                <table ref={tableRef} className="table table-striped table-bordered" style={{ width: '100%' }}></table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default AdminDeleted;
